import { Component } from '@angular/core';

@Component({
  selector: 'app-billing-service-details',
  templateUrl: './billing-service-details.component.html',
  styleUrls: ['./billing-service-details.component.css']
})
export class BillingServiceDetailsComponent {

}
